import { useContext } from "react"
import { PluginInstallsContext, type PluginInstallsContextValue } from "../context/plugin-installs-context"

export function usePluginInstalls(): PluginInstallsContextValue {
  const ctx = useContext(PluginInstallsContext)
  if (!ctx)
    throw new Error("usePluginInstalls must be used within a PluginInstallsProvider")
  return ctx
}
